import Text from '../Base/Text/Text';
// @ts-ignore
import styles from './Buttons.module.scss';
import { joinClasses } from '../../Utils/className.util';
import { Theme } from '../../Enums/Theme.enum';
import * as React from 'react';
import Loading, { LoadingSize } from '../Loading';

interface ButtonProps {
	onClick?: () => void;
	title?: string;
	theme?: Theme | string;
	className?: string;
	children?: string | React.ReactChild | React.ReactChild[];
	style?: object;
	badge?: string;
	disabled?: boolean;
	small?: boolean;
	fitContent?: boolean;
	isLoading?: boolean;
	firstUpper?: boolean;
	txParams?: Record<string, string | number>;
}

export default function Button(props: ButtonProps) {
	const {
		onClick,
		title,
		theme = Theme.BLUE,
		className,
		children,
		style,
		badge,
		disabled,
		small,
		isLoading,
		fitContent = false,
		firstUpper = true,
		txParams,
	} = props;

	const allowed = !disabled && !isLoading;
	const buttonTheme: Theme | string = !allowed ? Theme.DISABLED : theme;

	const handlePress = () => {
		onClick?.();
	};

	let majorStyleClassName = styles.button;

	if (small) {
		majorStyleClassName = styles.smallButton;
	}

	return (
		<div
			className={joinClasses([
				majorStyleClassName,
				styles[buttonTheme],
				className,
				fitContent ? styles.fitContent : '',
			])}
			onClick={allowed ? handlePress : undefined}
			style={style}>
			{isLoading && <Loading size={LoadingSize.SMALL} white />}
			<Text
				className={styles.title}
				inline={true}
				firstUpper={firstUpper}
				txParams={txParams}>
				{children || title}
			</Text>
			{badge && <Text className={styles.badge} tx={badge} inline />}
		</div>
	);
}
